import { useEffect, useState } from 'react';

import { type CurrentUserProfile, fetchCurrentUserProfile } from '../../../services/user-data';

export const useCurrentUserProfile = (): CurrentUserProfile | undefined => {
	const [currentUserProfile, setCurrentUserProfile] = useState<CurrentUserProfile>();

	useEffect(() => {
		let isActive = true;

		void fetchCurrentUserProfile().then((profile) => {
			if (isActive) {
				setCurrentUserProfile(profile);
			}
		});

		return () => {
			isActive = false;
		};
	}, []);

	return currentUserProfile;
};
